export class InfoCard {
  title: string;
  date: string;
  place: string;
  short: string;
}
